<!-- Large viewport -->
<div class="d-none d-lg-block">
  <div *ngFor="let sendgroup of sendGroups; let isFirstSendGroup = first;">
  <desktop-request-status-sendgroup-item [sendgroup]="sendgroup" [isFirstSendGroup]="isFirstSendGroup"></desktop-request-status-sendgroup-item>
  <!-- [sendgroupDeadlines]="getSendgroupDeadlines()" -->
  </div>
</div>